<template>
    <el-menu :default-active="$route.path" class="el-menu-vertical" text-color="inherit"
        active-text-color="#409EFF" router >
        <template v-for="item in routes">
            <!-- 一级菜单 -->
            <el-menu-item v-if="!item.children" :index="item.path" :key="item.path">
                <i :class="item.icon"></i>
                <span slot="title">{{ item.name }}</span>
            </el-menu-item>

            <!-- 有子菜单的一级菜单 -->
            <el-submenu v-if="item.children && item.children.length > 0" :index="item.path" :key="item.path">
                <template slot="title">
                    <i :class="item.icon"></i>
                    <span>{{ item.name }}</span>
                </template>
                <el-menu-item v-for="child in item.children" :key="item.path+ '/' + child.path" :index="child.path">
                    <i :class="child.icon"></i>
                    {{ child.name }}
                </el-menu-item>
            </el-submenu>
        </template>
    </el-menu>
</template>

<script>
export default {
    name: 'Sidebar',
    computed: {
        routes() {
            let r = JSON.parse(localStorage.getItem('route'));
            // 确保"数据看板"菜单始终在第一个位置
            if (r && Array.isArray(r)) {
                // 找到"数据看板"菜单项
                const dashboardIndex = r.findIndex(item => item.name === '数据看板' || item.path === '/dashboard');
                if (dashboardIndex > 0) {
                    // 如果"数据看板"不在第一个位置，将其移到第一个
                    const dashboardItem = r.splice(dashboardIndex, 1)[0];
                    r.unshift(dashboardItem);
                }
            }
            return r;
        }
    }
}
</script>